<template>
    <div>
        <el-dialog title="供应商信息" width="60%" :visible.sync="dialogVisible" @close='closeDialog'>
            <!-- <div slot="header" class="dialog-header"> -->
            <el-button type="primary" @click="dataFormSubmit()" size="mini" v-if="showEditButton">保 存</el-button>
            <el-button @click="dialogVisible = false" size="mini" v-if="!editflag">取 消</el-button>
            <!-- </div> -->
            <div>
                <el-form :model="temp" label-width="120px" :rules="dataRule" ref="temp" style="margin-top:5px">
                    <el-row :gutter="80">
                        <el-col :span="11">
                            <el-form-item label="供应商代码:" prop="venderCode">
                                <el-input :disabled="editflag" v-model="temp.venderCode"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                                <div slot="content">{{temp.venderName}}
            </div>
            <el-form-item label="供应商名称：" prop="venderName">
                <el-input :disabled="!showEditButton" v-model="temp.venderName"/>
            </el-form-item>
            </el-tooltip>
            </el-col>
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="供应商简称:" prop="venderAbbreviation">
                        <el-input :disabled="!showEditButton" v-model="temp.venderAbbreviation"/>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-tooltip placement="top" content='' effect="light">
                        <div slot="content">{{temp.venderAdd}}
    </div>
    <el-form-item label="供应商地址：" prop="venderAdd">
        <el-input :disabled="!showEditButton" v-model="temp.venderAdd"/>
    </el-form-item>
    </el-tooltip>
    </el-col>
    </el-row>
    <el-row :gutter="80">
        <el-col :span="11">
            <el-form-item label="联系人:" prop="venderContacts">
                <el-input :disabled="!showEditButton" v-model="temp.venderContacts"/>
            </el-form-item>
        </el-col>
        <el-col :span="11">
            <el-form-item label="电话：" prop="venderTel">
                <el-input :disabled="!showEditButton" v-model="temp.venderTel"/>
            </el-form-item>
        </el-col>
    </el-row>
    <el-row :gutter="80">
        <el-col :span="11">
            <el-form-item label="邮箱:" prop="venderMail">
                <el-input :disabled="!showEditButton" v-model="temp.venderMail"/>
            </el-form-item>
        </el-col>
        <el-col :span="11">
            <el-form-item label="数据来源：" prop="venderSource">
                <!-- <el-input :disabled="!showEditButton" v-model="temp.venderSource" /> -->
                <el-select :disabled="true" v-model="temp.venderSource" placeholder="请选择">
                    <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-col>
    </el-row>
    </el-form>
    </div>
    <div v-if="!showUsers">
        <hr/>
        <!--<usersInfo ref="usersInfo" v-bind:venderFid="venderId" @refreshDataList="getDataList"></usersInfo>-->
    </div>
    </el-dialog>
    </div>
</template>

<script>
    // import usersInfo from '../vender/venderUsers'

    export default {
        components: {
            // usersInfo
        },
        data() {
            return {
                dialogVisible: false,
                visible: false,
                temp: '',
                venderContacts: '',
                // dataForm: {
                //   venderId: 0,
                //   venderLogin: '',
                //   venderCareerBody: '',
                //   venderCode: '',
                //   venderName: '',
                //   venderAbbreviation: '',
                //   venderAdd: '',
                //   venderContacts: '',
                //   venderMail: '',
                //   venderMailBak: '',
                //   venderTel: '',
                //   venderSource: '',
                //   createdBy: '',
                //   createDate: '',
                //   updatedBy: '',
                //   updateDate: '',
                //   deletedBy: '',
                //   deleteDate: '',
                //   isDeleted: '',
                //   remark: '',
                //   optCounter: ''
                // },
                dataList: []
            }
        },
        methods: {
            // 获取数据列表
            getDataList(id, editFlag, venderSource) {
                this.dialogVisible = true
                this.visible = true
                this.venderSource = venderSource
                // alert(venderSource)
                this.$http({
                    url: this.$http.adornUrl('/venderinvite/tvenderinvite/tvenderInviteList'),
                    method: 'post',
                    params: this.$http.adornParams({
                        'venderFid': id,
                        'venderSource': venderSource
                    })
                }).then(({
                             data
                         }) => {
                    if (data && data.code === 0) {
                        this.editFlag = editFlag
                        this.dataList = data.tvenderInviteList
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                })
            },
            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            renderHeader(cerateElement, {
                column
            }) {
                return cerateElement("div", [
                    cerateElement("span", column.label),
                    cerateElement("span", {
                        domProps: {
                            innerHTML: "*"
                        },
                        style: {
                            color: "red",
                            fontSize: "16px",
                            marginLeft: "5px"
                        }
                    })
                ]);
            },
        }
    }
</script>
